import { render, staticRenderFns } from "./SpecialIcon.vue?vue&type=template&id=2c882428&scoped=true&"
import script from "./SpecialIcon.vue?vue&type=script&lang=js&"
export * from "./SpecialIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c882428",
  null
  
)

export default component.exports